import { render, staticRenderFns } from "./ADomainsTab.vue?vue&type=template&id=54ec5f90&"
import script from "./ADomainsTab.vue?vue&type=script&lang=js&"
export * from "./ADomainsTab.vue?vue&type=script&lang=js&"
import style0 from "./ADomainsTab.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports